import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateWeeklyReport = () => {
  deeplinkNavigation({ name: 'WeeklyReportWebView' })
}
